import { render } from "./ModifcarLlave.vue?vue&type=template&id=46950c7a&scoped=true"
import script from "./ModifcarLlave.vue?vue&type=script&lang=js"
export * from "./ModifcarLlave.vue?vue&type=script&lang=js"

import "./ModifcarLlave.vue?vue&type=style&index=0&id=46950c7a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\2. Fabrica 2022\\Proyecto_Andres_Fabrica\\proyecto_llaves\\version_principal\\frontend_proyecto_llaves\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46950c7a"]])

export default __exports__